import { ThemeColors } from '../../../'

export interface LoginPromptColors {
  Background: ThemeColors
  ApiEnvironmentToggle: {
    Background: ThemeColors
    TitleFontColor: ThemeColors
  }
}

export const loginPromptColors: LoginPromptColors = {
  Background: {
    default: 'bg.default',
  },
  ApiEnvironmentToggle: {
    Background: {
      default: 'brand.subtle',
    },
    TitleFontColor: {
      default: 'brand.fg',
    },
  },
}
